export default "__VITE_ASSET__i46Db2F3__"